import { ApiNetworkError } from '../errors';
export default (error, { reject, errors, config }) => {
    if (!error.response || error.code === '502' || error.code === '504') {
        const attempts = errors.length;
        // Stop trying if attempts exceed max allowed attempts
        if (attempts >= config.maxErrorAttempts) {
            if (error.response) {
                reject(error);
            }
            else {
                reject(new ApiNetworkError());
            }
        }
    }
    else {
        reject(error);
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXJyb3JNaWRkbGV3YXJlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL2xpYi9hcGkvbWlkZGxld2FyZXMvZXJyb3JNaWRkbGV3YXJlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUNBLE9BQU8sRUFBRSxlQUFlLEVBQUUsTUFBTSxXQUFXLENBQUM7QUFFNUMsZUFBZSxDQUFDLEtBQWUsRUFBRSxFQUFFLE1BQU0sRUFBRSxNQUFNLEVBQUUsTUFBTSxFQUFvQixFQUFRLEVBQUU7SUFDckYsSUFBSSxDQUFDLEtBQUssQ0FBQyxRQUFRLElBQUksS0FBSyxDQUFDLElBQUksS0FBSyxLQUFLLElBQUksS0FBSyxDQUFDLElBQUksS0FBSyxLQUFLLEVBQUU7UUFDbkUsTUFBTSxRQUFRLEdBQUcsTUFBTSxDQUFDLE1BQU0sQ0FBQztRQUMvQixzREFBc0Q7UUFDdEQsSUFBSSxRQUFRLElBQUksTUFBTSxDQUFDLGdCQUFnQixFQUFFO1lBQ3ZDLElBQUksS0FBSyxDQUFDLFFBQVEsRUFBRTtnQkFDbEIsTUFBTSxDQUFDLEtBQUssQ0FBQyxDQUFDO2FBQ2Y7aUJBQU07Z0JBQ0wsTUFBTSxDQUFDLElBQUksZUFBZSxFQUFFLENBQUMsQ0FBQzthQUMvQjtTQUNGO0tBQ0Y7U0FBTTtRQUNMLE1BQU0sQ0FBQyxLQUFLLENBQUMsQ0FBQztLQUNmO0FBQ0gsQ0FBQyxDQUFDIn0=